import component from './filterTraffic'

export default component
